import React, { useCallback } from 'react'
import {
  Box, IcoMoon, Text, ChatBubbleIcon,
} from '@usap/uicomponents'

export default function RMANeedHelp({ OpenChatHandler }) {
  const OpenChatBox = useCallback(e => {
    e.preventDefault()
    OpenChatHandler()
  }, [OpenChatHandler])

  return (
    <Box
      direction="row"
      align="center"
      onClick={OpenChatBox}
      style={{
        padding: '8px 16px',
        position: 'fixed',
        backgroundColor: '#FFFFFF',
        bottom: 8,
        right: 8,
        cursor: 'pointer',
        boxShadow: '0 0 5px 1px #eee',
        zIndex: 99,
        border: '1px solid #E0E0E0',
        borderRadius: '8px',
      }}
    >
      <IcoMoon icon={ChatBubbleIcon} style={{ marginRight: '4px' }} />
      <Text size="14px" weight="bold" color="#2E4787">
        Need help?
      </Text>
    </Box>
  )
}
